// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/KioskApp/mazebox-custom.scss
// module id = 100
// module chunks = 0